import React from 'react'

import ClientProfile from 'components/organisms/ClientProfile'
import LawyerProfile from 'components/organisms/LawyerProfile'
import useUserInfo from 'hooks/useUserInfo'

const Profile = () => {
  const [user] = useUserInfo()
  return user.role === 'lawyer' ? <LawyerProfile /> : <ClientProfile />
}

export default Profile
